import React from 'react';
import { Dropdown as BsDropdown } from 'react-bootstrap';
import makeBranch from './makeBranch';

function DropdownToggle(props) {
  return <button {...props} />;
}

const ToggleBranch = makeBranch(
  'ToggleBranch',
  BsDropdown.Toggle,
  DropdownToggle
);

ToggleBranch.defaultProps = {
  bsRole: 'toggle',
};

export default ToggleBranch;
